import PropTypes from 'prop-types';
import React from 'react';
import { CollapsibleModule } from '@surfline/quiver-react';
import nearbyBuoysPropType from '../../propTypes/nearbyBuoys';
import NearbyBuoysContent from './NearbyBuoysContent';
import CTAProvider from '../../containers/CTAProvider';
import NearbyBuoysCTA from '../NearbyBuoysCTA';

const segmentProperties = {
  ctaLocation: 'Nearby Buoys',
  pageName: 'Spot Report',
};

const NearbyBuoys = ({ fetchBuoys, nearbyBuoys, doTrackEvent, isPremium, spotId }) => (
  <div className="sl-nearby-buoys">
    <CollapsibleModule
      title="Nearby Buoys"
      onOpen={fetchBuoys}
      onClick={() =>
        doTrackEvent('Clicked Nearby Buoys', {
          pageName: 'Spot Report',
          category: 'cams & reports',
        })
      }
    >
      {!isPremium ? (
        <CTAProvider segmentProperties={{ ...segmentProperties, spotId }}>
          <NearbyBuoysCTA />
        </CTAProvider>
      ) : (
        <NearbyBuoysContent nearbyBuoys={nearbyBuoys} />
      )}
    </CollapsibleModule>
  </div>
);

NearbyBuoys.propTypes = {
  fetchBuoys: PropTypes.func,
  nearbyBuoys: nearbyBuoysPropType.isRequired,
  doTrackEvent: PropTypes.func.isRequired,
  isPremium: PropTypes.bool.isRequired,
  spotId: PropTypes.string.isRequired,
};

NearbyBuoys.defaultProps = {
  fetchBuoys: null,
};

export default NearbyBuoys;
